import Axios from './axiosUtil';
import store from './../../common/store';

const BASE_PATH = '/apps/ptb/'
const BASE_API_URL = `${BASE_PATH}api`;
const COMMISSIONS_API = `${BASE_API_URL}/commissions`;
import { convertQStringToDict } from '../../common/commomUtil'

export function getCommissionSummary(paidTin, sortBy, fromDate, toDate) {
  return Axios.post(`/apps/ptb/api/commissions/summary`, {
    producerIdentifier: paidTin, sortBy: sortBy, statementFromDate: fromDate, statementToDate: toDate
  })
}

// @MethodNotInUse After Version 1 Implementation below getCommissionSummaryCombinedDashboard
export function getCommissionSummaryDashboard(encryptedTaxId, year) {
  let url = `${COMMISSIONS_API}/summary/insights`;
  return Axios.post(
    url,
    Object.assign(
      {},
      {
        producerIdentifier: encryptedTaxId,
        year: year,
      }
    )
  );
}

export function getCommissionSummaryCombinedDashboard(encryptedTaxId, year, enableV4endPoint = false) {
  return Axios.post(`${COMMISSIONS_API}/summary/insights/v1`, {
    producerIdentifier: encryptedTaxId,
    year: year,
    enableV4endPoint: enableV4endPoint,
  });
}

/** ****BPP-2195-sheeba******/
// Method was used in old commission details page
export function getCommissionDetails(statementId, sortBy, pageNumber, pageSize, filter) {
   let allFilterParams = ''
  // pushing the filter obj to an array to make a queryString
  for (var field in filter) {
    allFilterParams += `&${field}=${filter[field].valueForApi || filter[field].data}`;
  }
  const { homeReducers = {} } = store.getState();
  const encryptedTaxId = homeReducers?.bpUserInfo?.profileObj?.profile?.producer?.encryptedTaxId
  const filterObject = convertQStringToDict(allFilterParams, { isDecodeValue: true })
  const payLoad = { pageNumber, pageSize, sortBy, producerIdentifier: encryptedTaxId, statementId, ...filterObject }
  return Axios.post(`${BASE_API_URL}/commissions/details`, payLoad).then(res => convertCDResponseData(res))
}

export function getClientConfig() {
  return Axios.get(`${BASE_API_URL}/config`);
}

// Fetch Public Configs
export function getPublicClientConfig() {
  return Axios.get(`${BASE_PATH}auth/api/getconfigs`);
}

export function getBPUserToken(isUserOrTINSelected = false) {
  return Axios({ url: `${BASE_API_URL}/token`, method: 'post', isUserOrTINSelected });
}
